import { LOGIN_SUCCESS, LOGOUT } from "./actionTypes";

const INIT_STATE = {
  firstname: null,
  lastname: null,
  email: null,
  token: null,
  profileImg:null
};

export default function Admin(state = INIT_STATE, action) {

  switch (action.type) {
    case LOGIN_SUCCESS: {
      return {
        ...state,
        firstname: action.payload.firstName,
        lastname: action.payload.lastName,
        email: action.payload.email,
        token: action.payload.token,
        profileImg:action.payload.firstName,
      };
    }
    case LOGOUT:
      return INIT_STATE;
    default:
      return state;
  }
}
